var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-case", on: { click: _vm.clickCase } }, [
    _c("figure", { staticClass: "card-case__image" }, [_vm._t("image")], 2),
    _c("div", { staticClass: "card-case__title" }, [_vm._t("title")], 2),
    _c("div", { staticClass: "card-case__subtitle" }, [_vm._t("subtitle")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6769c9a4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6769c9a4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/card-case-view.vue
// module id = 511
// module chunks = 86